export var AssetSyncStatus;
(function (AssetSyncStatus) {
    AssetSyncStatus[AssetSyncStatus["InSync"] = 0] = "InSync";
    AssetSyncStatus[AssetSyncStatus["OutOfSync"] = 1] = "OutOfSync";
    AssetSyncStatus[AssetSyncStatus["SyncConflict"] = 2] = "SyncConflict";
    AssetSyncStatus[AssetSyncStatus["SyncError"] = 3] = "SyncError";
    AssetSyncStatus[AssetSyncStatus["Syncing"] = 4] = "Syncing";
})(AssetSyncStatus || (AssetSyncStatus = {}));
export var AssetSyncSuspensionReason;
(function (AssetSyncSuspensionReason) {
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["None"] = 0] = "None";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["CloudContentCorrupted"] = 1] = "CloudContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["LocalContentCorrupted"] = 2] = "LocalContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyComponents"] = 3] = "HasTooManyComponents";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyChildren"] = 4] = "HasTooManyChildren";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["MaximumSizeExceeded"] = 5] = "MaximumSizeExceeded";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["Unknown"] = 6] = "Unknown";
})(AssetSyncSuspensionReason || (AssetSyncSuspensionReason = {}));
/**
 * Response from the server for the commit request.
 **/
export var CommitStatus;
(function (CommitStatus) {
    CommitStatus[CommitStatus["NoErr"] = 0] = "NoErr";
    CommitStatus[CommitStatus["Conflict"] = 1] = "Conflict";
    CommitStatus[CommitStatus["DeleteConflict"] = 2] = "DeleteConflict";
    CommitStatus[CommitStatus["ParentDeletedConflict"] = 3] = "ParentDeletedConflict";
})(CommitStatus || (CommitStatus = {}));
